import { Education } from "./type";

export function convertToTitleCase(string: string) {
  const str = string.toLowerCase().split(" ");
  for (let i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(" ");
}

//order: highest, null end_date, then ascending end_date
export function sortHighestThenByEndDate(educationQualifications: Education[]) {
  const sortedQualifications = educationQualifications.sort((a, b) => {
    if (a.end_date === null && b.end_date === null) return 0;
    if (a.end_date === null) return -1;
    if (b.end_date === null) return 1;
    return 0;
  });

  sortedQualifications.sort((a, b) => {
    if (a.end_date === null || b.end_date === null) return 0;
    return new Date(a.end_date).getTime() - new Date(b.end_date).getTime();
  });

  const highestLevelIndex = sortedQualifications.findIndex(
    (item) => item.highest_level === true
  );

  if (highestLevelIndex !== -1) {
    const highestLevelItem = sortedQualifications.splice(
      highestLevelIndex,
      1
    )[0];
    sortedQualifications.unshift(highestLevelItem);
  }

  return sortedQualifications;
}
